/**
 * Description: Landing page of the Audit Tool. Auditor can either start review or access dashboard.
 */
import React from 'react';
import {
  AppLayout,
  Button,
} from 'AWS-UI-Components-React';
import {CustomNavigation} from './customNavigation.jsx';
import {JSClient} from './common.jsx';

export class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {initialLoadDone: false, user: ""};
    this.clientLoaded = this.clientLoaded.bind(this);
  }

  clientLoaded() {
    this.client.getIdentity(identityResult => {
        this.setState({ user: identityResult.username, initialLoadDone: true });   
    });
  }

  componentWillMount() {
    this.client = new JSClient({ onReady: this.clientLoaded });
  }

  render() {
    if (!this.state.initialLoadDone) {
      return <div>
        <center>
	        <h1>Authorizing user please wait.</h1>
        </center>
      </div>
    }

    const MainContent = () => (
      <div>
        <div className="awsui-util-m-xxl">
          <h1><center>Audit Tool</center></h1>
          <h2><center>Welcome {this.state.user.charAt(0).toUpperCase() + this.state.user.slice(1)}</center></h2>
        </div>
          <div className="awsui-util-m-xxl">
            <center>
              <Button text="Start Audit" variant="primary" href="/review"></Button>
              <Button text="Audited Outfits" variant="primary" href="/browse"></Button>
              <Button text="Dashboard" variant="primary" href="/dashboard"></Button>
            </center>
          </div>
      </div>
    );

    return (
      <div className="awsui">
        <AppLayout
          className='awsui-util-no-gutters'
          content={<MainContent/>}
          navigation={<CustomNavigation />}
          toolsHide={true}
          navigationOpen={false}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/mainpage.jsx